import { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element } from '@src/mixins/element/element'

import './radio.sass'

@Component
export class Radio extends Mixins<Element>(Element) {

  @Prop({ required: false })
  value: string

  @Prop({ required: false })
  text: string

  @Prop({ required: false })
  bindedProp: string

  @Prop({ required: false })
  change: (val) => void

  isRadioSelected: boolean = false

  render (h: CreateElement) {
    return (
      this.renderInput(h, this.disabled)
    )
  }

  mounted () {
    this.isRadioSelected = this.bindedProp === this.value
  }

  updated () {
    this.isRadioSelected = this.bindedProp === this.value
  }

  changeValue () {
    if (this.change) {
      if (this.bindedProp === this.value) {
        this.isRadioSelected = false
        this.change('')
      } else {
        this.isRadioSelected = true
        this.change(this.value)
      }
    }
  }

  protected renderInput (h: CreateElement, disabled: boolean) {
    return <el-radio class={this.isRadioSelected ? 'bullet-check-input' : ''} label={this.bindedProp} onChange={this.changeValue}>
      {this.text}
    </el-radio>
  }
}
